import React from 'react';
import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';

const BreadcrumbsWrapper = styled.nav`
    flex-grow: 1;
`;

const BreadcrumbList = styled.ol`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
`;

const BreadcrumbItem = styled.li`
  display: flex;
  align-items: center;
  
  &:not(:last-child)::after {
    content: '/';
    margin: 0 0.5rem;
    color: #666;
  }
`;

const StyledLink = styled(Link)`
  color: #666;
  text-decoration: none;
  
  &:hover {
    color: #333;
  }
`;

const CurrentPage = styled.span`
  color: #333;
  font-weight: 500;
`;

const Breadcrumbs = ({ items }) => {
  const navigate = useNavigate();

  return (
    <BreadcrumbsWrapper>
      <BreadcrumbList>
        {items.map((item, index) => (
          <BreadcrumbItem key={index}>
            {index === items.length - 1 ? (
              <CurrentPage>{item.label}</CurrentPage>
            ) : (
              <StyledLink 
                onClick={(e) => {
                  e.preventDefault();
                  navigate(item.path);
                }}
                href={item.path}
              >
                {item.label}
              </StyledLink>
            )}
          </BreadcrumbItem>
        ))}
      </BreadcrumbList>
    </BreadcrumbsWrapper>
  );
};

export default Breadcrumbs;
